export const QuestionHelp = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.1263 7.70866C8.1263 7.0183 8.68595 6.45866 9.3763 6.45866H10.3835C11.208 6.45866 11.8763 7.12699 11.8763 7.95142C11.8763 8.45053 11.6269 8.91662 11.2116 9.19348L10.7435 9.50555C10.2798 9.81466 10.0013 10.335 10.0013 10.8923V11.042M10.0013 13.3337V13.3253M17.7096 10.0003C17.7096 14.2575 14.2585 17.7087 10.0013 17.7087C5.74411 17.7087 2.29297 14.2575 2.29297 10.0003C2.29297 5.74313 5.74411 2.29199 10.0013 2.29199C14.2585 2.29199 17.7096 5.74313 17.7096 10.0003ZM10.2096 13.3337C10.2096 13.4487 10.1164 13.542 10.0013 13.542C9.88624 13.542 9.79297 13.4487 9.79297 13.3337C9.79297 13.2186 9.88624 13.1253 10.0013 13.1253C10.1164 13.1253 10.2096 13.2186 10.2096 13.3337Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default QuestionHelp
